export const ExperimentsConsts = {
  MembersAreaLazyLoad: 'specs.bookings.members-area-lazy-load',
  WixFormsMigration: 'specs.bookings.WixFormsMigration',
  UseMoment: 'specs.bookings.MyBookingsUseMoment',
  AddonsUOU: 'specs.bookings.AddonsUOU'
};
